import NominationRewardsList from 'src/allrewards/presentation/NominationRewardsList/NominationRewardsList.jsx';

const NominationRewardsListContainer = (props) => {
	const {
		title,
		openNomination,
		nominatedAwardWinner,
		badgeList,
		winningNominations,
		currentUser,
	} = props;

	return (
		<NominationRewardsList
			title={title}
			openNomination={openNomination}
			winningNominations={winningNominations}
			nominationsList={badgeList}
			nominatedAwardWinner={nominatedAwardWinner}
			emptyString={props.emptyString}
			currentUser={currentUser}
		/>
	);
};

export default NominationRewardsListContainer;
